import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const ContainerWithImage = props => {
  const { img, title, description, styles} = props
  const classes = useStyles({styles})
  return (
    <div className={classes.containerWithImage}>
      <div className={classes.container}>
        <img
          className={classes.img}
          src={img}
          alt={title}
        />
        <img
          className={classes.imgFaded}
          src={img}
          id='secImg'
          alt={title}
        />
        <div className={classes.content}>
          <h4> {title} </h4>
          <p> {description} </p>
        </div>
      </div>
    </div>
  )
}

ContainerWithImage.propTypes = {
  img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  styles: PropTypes.object,
}

const useStyles = createUseStyles({
  containerWithImage: props => ({
    borderRadius: '2px',
    height: '150px',
    marginBottom: '2em',
    border: '4px dashed',
    position: 'relative',
    width: '30%',
    boxSizing: 'border-box',
    ...props.styles,
    '&:hover': {
      boxShadow: '0px 0px 10px 5px rgba( 0, 0, 0, 0.4 )',
      '& #secImg': {
        transform: 'translateX(-60px)',
      },
    },
  }),
  img: {
    width: '12%',
    height: '15%',
    marginTop: '1.5em',
    marginLeft: '1em',
  },
  imgFaded: {
    opacity: '.05',
    position: 'absolute',
    right: '15px',
    transition: 'all .5s',
  },
  container: {
    display: 'flex',
  },
  content: {
    zIndex: '3',
    marginLeft: '1em',
    '& h4': {
      color: 'white',
      marginBottom: '0.4em',
    },
    '& p': {
      fontSize: '16px',
    },
  },
  '@media (max-width: 960px)': {
    containerWithImage: {
      width: '100% !important',
    },
  },
})

export default ContainerWithImage
